/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbQuerySyncLogService extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ServiceNowCmdbQuerySyncLogService");
    }

    getFixupPrototypeFunction() { return ServiceNowCmdbQuerySyncLogService.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbQuerySyncLogService>): ServiceNowCmdbQuerySyncLogService {
        let obj = Object.assign(new ServiceNowCmdbQuerySyncLogService(), model);
        ServiceNowCmdbQuerySyncLogService.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbQuerySyncLogService>): ServiceNowCmdbQuerySyncLogService {
        if (!model) return null;
        return ServiceNowCmdbQuerySyncLogService.newInstance(<ServiceNowCmdbQuerySyncLogService> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbQuerySyncLogService) {
        if (!obj) return;

        models.ServiceNowCmdbQuerySyncLogService.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbQuerySyncLogService): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbQuerySyncLogService.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Type or category of the cloud resource being synchronized
     */
    services: Array<string>;

}
